import {
  Card,
  CardContent,
  CardDescription,
  CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";

type CardSupportProps = {
  title: string;
  desc: string;
  href?: string;
};

export default function CardSupport({ desc, title, href }: CardSupportProps) {
  return (
    <Link href={href ?? "/"} className="w-full" target="_blank">
      <Card className="relative overflow-hidden  md:min-h-[15rem] bg-white duration-300 cursor-pointer group">
        <CardContent className="p-5 md:p-10 flex justify-between w-full h-full items-center gap-x-5 relative z-10">
          <div className="w-[20%]">
            <Image
              src={"/assets/images/dprdpali.png"}
              width={300}
              height={300}
              alt="support-office"
              className="row-span-2 w-12 md:w-24 h-12 md:h-24 aspect-square"
            />
          </div>
          <div className="flex flex-col h-full w-full gap-y-4">
            <CardTitle className="text-base md:text-xl text-text-800">
              {title}
            </CardTitle>
            <CardDescription className="text-sm md:text-base text-primary">
              {desc}
            </CardDescription>
          </div>
        </CardContent>
        {/*  */}
        <Decoration className="absolute -top-16 -left-10 group" />
        <Decoration className="absolute bottom-0 -right-10 overflow-visiblex" />
      </Card>
    </Link>
  );
}

const Decoration = ({ className }: { className?: string }) => {
  return (
    <div className={cn(className, "group-hover:rotate-12 duration-300")}>
      <svg
        width="140"
        height="140"
        viewBox="0 0 140 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="0.203637"
          x="51.2139"
          y="6.40698"
          width="94.2963"
          height="94.2963"
          rx="29"
          transform="rotate(30 51.2139 6.40698)"
          fill="#C2E8C4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.1228 2.48408C70.7508 1.11209 68.5266 1.11209 67.1546 2.48408C65.7829 3.85573 65.7826 6.08025 67.1546 7.45224C68.5266 8.82423 70.7511 8.82389 72.1228 7.45224C73.4947 6.08025 73.4947 3.85607 72.1228 2.48408"
          fill="#9FDBA2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.5661 24.0408C49.1941 22.6688 46.9699 22.6688 45.598 24.0408C44.2263 25.4125 44.226 27.637 45.598 29.009C46.9699 30.381 49.1945 30.3807 50.5661 29.009C51.9381 27.637 51.9381 25.4128 50.5661 24.0408"
          fill="#9FDBA2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.0095 45.5975C27.6375 44.2255 25.4133 44.2255 24.0413 45.5975C22.6693 46.9695 22.6693 49.1936 24.0413 50.5656C25.4133 51.9376 27.6375 51.9376 29.0095 50.5656C30.3815 49.1936 30.3815 46.9695 29.0095 45.5975"
          fill="#9FDBA2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.45283 67.1541C6.08084 65.7821 3.85632 65.7825 2.48467 67.1541C1.11268 68.5261 1.11268 70.7503 2.48467 72.1223C3.85666 73.4943 6.08084 73.4943 7.45283 72.1223C8.82448 70.7506 8.82482 68.5261 7.45283 67.1541"
          fill="#9FDBA2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M93.6796 24.041C92.3076 22.669 90.0835 22.669 88.7115 24.041C87.3398 25.4126 87.3395 27.6371 88.7115 29.0091C90.0835 30.3811 92.308 30.3808 93.6796 29.0091C95.0516 27.6371 95.0516 25.413 93.6796 24.041"
          fill="#9FDBA2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.123 45.5976C70.751 44.2256 68.5268 44.2256 67.1548 45.5976C65.7832 46.9693 65.7828 49.1938 67.1548 50.5658C68.5268 51.9378 70.7513 51.9374 72.123 50.5658C73.495 49.1938 73.495 46.9696 72.123 45.5976"
          fill="#9FDBA2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.5664 67.1544C49.1944 65.7824 46.9702 65.7824 45.5982 67.1544C44.2262 68.5264 44.2262 70.7505 45.5982 72.1225C46.9702 73.4945 49.1944 73.4945 50.5664 72.1225C51.9383 70.7505 51.9383 68.5264 50.5664 67.1544"
          fill="#9FDBA2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.0095 88.711C27.6375 87.339 25.413 87.3394 24.0413 88.711C22.6693 90.083 22.6693 92.3072 24.0413 93.6792C25.4133 95.0512 27.6375 95.0512 29.0095 93.6792C30.3811 92.3075 30.3815 90.083 29.0095 88.711"
          fill="#9FDBA2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M115.236 45.5976C113.864 44.2256 111.64 44.2256 110.268 45.5976C108.896 46.9693 108.896 49.1938 110.268 50.5658C111.64 51.9378 113.865 51.9374 115.236 50.5658C116.608 49.1938 116.608 46.9696 115.236 45.5976"
          fill="#9FDBA2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M93.6796 67.1544C92.3076 65.7824 90.0835 65.7824 88.7115 67.1544C87.3398 68.526 87.3395 70.7505 88.7115 72.1225C90.0835 73.4945 92.308 73.4942 93.6796 72.1225C95.0516 70.7505 95.0516 68.5264 93.6796 67.1544"
          fill="#9FDBA2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.123 88.711C70.751 87.339 68.5268 87.339 67.1548 88.711C65.7828 90.083 65.7828 92.3072 67.1548 93.6792C68.5268 95.0512 70.751 95.0512 72.123 93.6792C73.495 92.3072 73.495 90.083 72.123 88.711"
          fill="#9FDBA2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.5661 110.268C49.1941 108.896 46.9696 108.896 45.598 110.268C44.226 111.64 44.226 113.864 45.598 115.236C46.9699 116.608 49.1941 116.608 50.5661 115.236C51.9378 113.864 51.9381 111.64 50.5661 110.268"
          fill="#9FDBA2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M115.236 88.711C113.864 87.339 111.64 87.339 110.268 88.711C108.896 90.0827 108.896 92.3072 110.268 93.6792C111.64 95.0512 113.865 95.0508 115.236 93.6792C116.608 92.3072 116.608 90.083 115.236 88.711"
          fill="#9FDBA2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M93.6796 110.268C92.3076 108.896 90.0835 108.896 88.7115 110.268C87.3395 111.64 87.3395 113.864 88.7115 115.236C90.0835 116.608 92.3076 116.608 93.6796 115.236C95.0516 113.864 95.0516 111.64 93.6796 110.268"
          fill="#9FDBA2"
        />
      </svg>
    </div>
  );
};
